var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBoost(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "20px",
    viewBox: "0 0 12.0 20.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,812 L0,812 L0,0 L375,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.10782457,0.272387376 C7.2614698,0.0291125226 7.57043666,-0.0656633058 7.83312672,0.047397123 C8.09753217,0.161042347 8.2397544,0.4494634 8.16950099,0.728722659 L6.42766863,7.64135424 L11.1111774,7.64135424 C11.3241988,7.64135424 11.5206511,7.75729966 11.6234581,7.9440443 C11.7262651,8.13020414 11.7194035,8.35807938 11.6057583,8.53854722 L4.58821444,19.6886447 C4.43398442,19.9322704 4.12696687,20.0265004 3.86291229,19.9136349 C3.59846785,19.7999897 3.45628461,19.5116076 3.52653802,19.2323094 L5.26837038,12.3196778 L0.58486161,12.3196778 C0.371840167,12.3196778 0.175387925,12.2037324 0.0725809079,12.0169878 C-0.0302261096,11.8308279 -0.0233645112,11.6029527 0.090280713,11.4224848 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-337.0 -749.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.0 690.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.0 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(325.0 52.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.038920066730496 7.038957652803672)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-1.52655666e-16,0 11.696039,0 11.696039,19.9610076 -1.52655666e-16,19.9610076 -1.52655666e-16,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBoost);
export default __webpack_public_path__ + "static/media/icBoost.5d03ece506cdb05a9f8fcceab8d051c9.svg";
export { ForwardRef as ReactComponent };